<template>
  <div class="client-information-content">
      <v-container container--fluid grid-list-md>
         <v-row justify="space-around" align="center">
          <!--<v-col cols="6" class="font-weight-bold">{{item.text}}</v-col>-->
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in filteredItems" :key="index">
            <v-text-field
              outlined
              :label="item.text"
              :readonly="readonly && ['ID', 'Name'].includes(item.text)"
              v-model="clientInfo[item.key]"
              :error="isFieldInvalid(item.key)"
            ></v-text-field>
          </v-col>

         <v-col cols="6">
           <v-autocomplete
             outlined
             :items="apiKeyItems"
             v-model="clientInfo.api_access_level"
             item-text="name"
             item-value="id"
             label="Api Access level"
             :error="isFieldInvalid('api_access_level')"
           >
           </v-autocomplete>
         </v-col>

          <v-col cols="6">
           <v-autocomplete
             outlined
             :items="countryItems"
             v-model="clientInfo.default_country"
             item-text="name"
             item-value="id"
             label="Country"
             :rules="[v => !!v || 'Country is required']"
             :error="isFieldInvalid('default_country')"
             required
           >
           </v-autocomplete>
         </v-col>

          <v-col cols="6">
            <v-card outlined class="pa-3 pb-2">
              <v-switch
                label="Active"
                v-model="clientInfo.active"
                @change="activateOrDeactivate"
                :disabled="!hasOracleSiteNumber"
                class="mt-0 mb-n2"
              ></v-switch>
              <div v-if="!hasOracleSiteNumber">
                <v-btn
                  text
                  color="primary"
                  x-small
                  @click="$emit('focus-oracle-site-number')"
                  class="text-none px-0"
                  style="height: auto; min-height: 24px;"
                >
                  <v-icon left x-small>mdi-link</v-icon>
                  <span style="font-size: 12px;">Provide Oracle Site Number First</span>
                </v-btn>
              </div>
            </v-card>
          </v-col>
          <v-col v-if="this.clientInfo && this.clientInfo.id > 0" cols="12" class="justify-center">
            <v-row style="flex-direction: column">
              <h3 class="mx-auto">Logo</h3>
              <v-img class="mx-auto my-4" :src="clientLogo" width="150px"></v-img>
              <v-btn text color="indigo" @click="$refs.manifest.click()">
                <div>Change Logo</div>
              </v-btn>
              <input v-show="false" ref="manifest" type="file" accept="image/*" @change="handleFileUpload">
            </v-row>


          </v-col>
         </v-row>
      </v-container>

      <v-dialog v-model="validationDialog" max-width="600">
        <v-card>
          <v-card-title class="headline">Client cannot be activated</v-card-title>
          <v-card-text>
            <p>Please correct the following fields before activating the client:</p>
            <v-list dense>
              <v-list-item v-for="error in validationErrors" :key="error.field">
                <v-list-item-content>
                  <v-list-item-title>{{ formatValidationField(error.field) }}</v-list-item-title>
                  <v-list-item-subtitle>{{ error.message }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="validationDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'

  // @group EditClient
  // Client Information tab for EditClientPage
  export default {
    props: {
      // Client Object
      clientInfo: Object,
      // Readonly Boolean
      readonly: Boolean,
    },
    name: "ClientInformation",
    data() {
      return {
        items: [
          {text: 'ID', key: 'id'},
          {text: 'Name', key: 'name'},
          {text: 'Address', key: 'address'},
          {text: 'Address 2', key: 'address2'},
          {text: 'Suburb', key: 'suburb'},
          {text: 'State', key: 'state'},
          {text: 'Postcode', key: 'postcode'},
          {text: 'Phone', key: 'phone'},
          {text: 'Invoice Text', key: 'invoice_text'},
          {text: 'Email Domain', key: 'google_domain'},
        ],
        countryItems: [
          {id: 'AUS', name: 'Australia'},
          {id: 'NZL', name: 'New Zealand'},
        ],
        apiKeyItems : [
          {id:null, name:'None'},
          {id:'staging', name:'Staging'},
          {id:'production', name:'Production'},
        ],
        validationDialog: false,
        validationErrors: []
      }
    },
    computed: {
      filteredItems() {
        if (!this.clientInfo || !this.clientInfo.id || this.clientInfo.id === 0) {
          return this.items.filter(item => item.key !== 'id');
        }
        return this.items;
      },
      clientLogo() {
        if (!this.clientInfo || this.clientInfo.logo === null || this.clientInfo.logo.length === 0) {
          return "http://bcrc.io/logo.png";
        } else {
          return this.clientInfo.logo;
        }
      },
      invalidFields() {
        return this.$store.state.invalidFields || [];
      },
      isFieldInvalid() {
        return (fieldName) => this.invalidFields.includes(fieldName);
      },
      hasOracleSiteNumber() {
        return !!(this.clientInfo && this.clientInfo.oracle_site_number &&
          String(this.clientInfo.oracle_site_number).trim().length > 0);
      }
    },
    methods: {
      // @vuese
      // Makes the calls to activate or deactivate the client depending on the previous position of the toggle
      activateOrDeactivate() {
        if (!this.clientInfo || !this.clientInfo.id || this.clientInfo.id === 0) {
          return;
        }
        let suffix = '';
        if (this.clientInfo.active) {
          suffix = '/activate';
        } else {
          suffix = '/deactivate';
        }
        axios.post(process.env.API_URL + '/clients/' + this.clientInfo.id + suffix)
          .then((response) => {
            if (response.status === 400) {
            }
          })
          .catch((error) => {
            const responseData = error.response && error.response.data;
            if (responseData && responseData.validation_errors) {
              this.validationErrors = Object.keys(responseData.validation_errors).map((field) => ({
                field,
                message: responseData.validation_errors[field]
              }));
              this.validationDialog = true;
            } else if (responseData) {
                this.$store.commit('displaySnackbar', 'ERROR: ' + responseData.error);
            } else {
                this.$store.commit('displaySnackbar','ERROR: activate/deactivate failed');
            }
            this.clientInfo.active = !this.clientInfo.active;
          })
      },
      formatValidationField(field) {
        return field
          .replace(/_/g, ' ')
          .replace(/\b\w/g, (letter) => letter.toUpperCase());
      },
      handleFileUpload() {
        let upload = new FormData();
        upload.append('logo', this.$refs.manifest.files[0]);
        axios({
          method: 'post',
          url: process.env.API_URL + '/clients/' + this.clientInfo.id + '/logo',
          data: upload,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            if (response.status === 200) {
              this.clientInfo.logo = response.data.url;
              this.$store.commit('displaySnackbar', "New logo uploaded");
            } else {
              this.$emit('alert', 'ERROR: An unknown problem occurred');
            }
          })
          .catch((error) => {
            if (error.response !== undefined) {
                this.$store.commit('displaySnackbar', 'ERROR: ' + error.response.data.error);
            } else {
                this.$store.commit('displaySnackbar', 'ERROR: An unknown problem occurred');
            }
          })
      },
    },
  }
</script>

<style scoped>
.client-information-content {
  /* No card wrapper needed - parent provides padding */
}

.v-text-field,
.v-autocomplete {
  margin-bottom: 8px;
}

/* Ensure proper input field sizing */
.v-text-field.v-text-field--outlined >>> .v-input__control {
  min-height: 56px;
}

.v-text-field.v-text-field--outlined >>> .v-input__slot {
  min-height: 48px;
}

.v-autocomplete.v-autocomplete--outlined >>> .v-input__control {
  min-height: 56px;
}

.v-autocomplete.v-autocomplete--outlined >>> .v-input__slot {
  min-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientInformation.vue